const driver = 'cookie';

export function getItem(name) {
	return (driver == 'session') ? getSessionItem(name) : getCookieItem(name)
}

export function setItem(name, data) {
	if (driver == 'session') {
		setSessionItem(name, data)
	} else {
		setCookieItem(name, data)
	}
}

function getSessionItem(name) {
	return JSON.parse(window.sessionStorage.getItem(name));
}

function setSessionItem(name, data) {
	window.sessionStorage.setItem(name, JSON.stringify(data))
}

function getCookieItem(name) {
	let result = document.cookie.match(new RegExp(name + '=([^;]+)'));
	console.log(result)
	result && (result = JSON.parse(result[1]));
	return result;
}

function setCookieItem(name, data) {
	let date = new Date();
	date.setTime(date.getTime() + (9 * 60 * 60 * 1000));
	let expires = "; expires=" + date.toGMTString();
	let cookie = [name, '=', JSON.stringify(data), '; path=/', expires].join('');
	console.log(cookie)
	document.cookie = cookie;
}